// Curated set of Font Awesome 6 solid icon classes admins can pick from for a
// prompt template. Keep in sync with crm-api's App\PromptTemplates\PromptIconRegistry.
export const DEFAULT_PROMPT_ICON = "fa-comment";

export const PROMPT_ICON_OPTIONS = [
  { value: DEFAULT_PROMPT_ICON, label: "Comment" },
  { value: "fa-file-alt", label: "Document" },
  { value: "fa-clipboard-list", label: "Clipboard" },
  { value: "fa-search", label: "Search" },
  { value: "fa-user-check", label: "Patient Check" },
  { value: "fa-flask", label: "Lab" },
  { value: "fa-stethoscope", label: "Exam" },
  { value: "fa-pills", label: "Medication" },
  { value: "fa-exclamation-triangle", label: "Alert" },
  { value: "fa-notes-medical", label: "Medical Notes" },
  { value: "fa-heartbeat", label: "Vitals" },
  { value: "fa-file-medical", label: "Medical Record" },
  { value: "fa-file-medical-alt", label: "Medical Report" },
  { value: "fa-user-md", label: "Provider" },
  { value: "fa-hospital", label: "Clinic" },
  { value: "fa-calendar-check", label: "Appointment" },
  { value: "fa-clipboard-check", label: "Checklist" },
  { value: "fa-comment-medical", label: "Clinical Note" },
  { value: "fa-chart-line", label: "Trend" },
  { value: "fa-list-check", label: "Task List" },
  { value: "fa-book-medical", label: "Reference" },
  { value: "fa-vial", label: "Sample" },
  { value: "fa-syringe", label: "Injection" },
  { value: "fa-diagnoses", label: "Diagnosis" },
  { value: "fa-prescription", label: "Prescription" },
  { value: "fa-prescription-bottle-medical", label: "Medication Bottle" },
  { value: "fa-user-injured", label: "Injury" },
  { value: "fa-briefcase-medical", label: "Care Kit" },
  { value: "fa-clock", label: "Time" },
  { value: "fa-bell", label: "Reminder" },
];
